import { render, staticRenderFns } from "./ChanpinGuige.vue?vue&type=template&id=155effce&scoped=true&"
import script from "./ChanpinGuige.vue?vue&type=script&lang=js&"
export * from "./ChanpinGuige.vue?vue&type=script&lang=js&"
import style0 from "./ChanpinGuige.vue?vue&type=style&index=0&id=155effce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155effce",
  null
  
)

export default component.exports